/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

import {Version} from '@angular/core';

/** Current version of Angular Material. */
export const VERSION = new Version('20.0.2');
